import React, { FC, useEffect, useState, useCallback } from "react";
import { Modal, Row, Col, List, Skeleton, Card, Input, Button } from "antd";
import _ from "lodash";
import { pushNotification } from "utils/notifications";
import { uuid } from "uuidv4";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import MyDocument from "../../../common/PdfPreview";
import {
  getMessageRequestPayload,
  wrapRequestPayload,
} from "../../../helpers/request/RequestPayload";
import "./index.scss";
import AddSurveyModal from "./AddSurveyModal";
import {
  ExtendedBioTopics,
  ModalType,
  ProjectTopics,
  QuestionaireType,
  SocketTopics,
  SurveyQuestionTopics,
  UserTopics,
} from "../../../constants/enums";
import { getParameterByName } from "../../../common/helpers";
import { pdf } from "@react-pdf/renderer";
import {
  getUserRolesPath,
  getVehicleExtendedBioPath,
  getUserSurveyPath,
  getExtendedBioPath,
  getProjectPath,
} from "../../../hooks/socketConstants";
import useSocketActions from "../../../hooks/socketActions";
import useLocalStorage from "../../../services/localStorage";
import { RootState } from "reducers/rootReducer";
import {
  GET_SURVEY,
  ADD_SURVEY,
  GET_SURVEY_ANSWER,
  GET_PROJECT_SURVEY_ID,
} from "reducers/reducer";
import { GET_AGGREGATE } from "../../../reducers/reducer";

import {
  DeleteQuestionareButton,
  AddQuestionareButton,
  EditQuestionaireButton,
  CopyQuestionareButton,
  EditQuestionaireCheckboxButton,
} from "./SurveyButtons";

import { MainActions, MathOps, LogicalOps, GeofenceOps } from "./SurveyEnums";
import ReactDOM from "react-dom";
import { ReactSVG } from "react-svg";
import {
  getSearchMessagePublishTopic,
  getSearchMessageSubscriptionTopic,
} from "hooks/MQTTConstants";
import { generateUUID } from "utils/appUtil";
import { UPLOAD_MEDIA } from "../../../reducers/reducer";

declare global {
  interface Window {
    webkit: any;
  }
}

declare var JSBridge: any;

const SurveyListModal: FC<{ socket: ISocket; onClose: () => void }> = ({
  onClose,
  socket,
}) => {
  const [surveyModalDisplayed, setSurveyModalDisplayed] = useState(false);
  const [selectedQuestionaire, setselectedQuestionaire] = useState<IQuestion>();
  const [initLoading, setInitLoading] = useState<boolean>(true);
  const [type, setType] = useState<string>(ModalType.Survey);
  const [track, setTrack] = useState<string[]>([]);

  const [isEditQuestion, setIsEditQuestion] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [user, setUser] = useState<any>({});
  const [count, setCount] = useState<any>(0);

  const [pageId, setPageId] = useState<string>();
  const [connectionId, setConnectionId] = useState<string>();
  const [liveUserId, setLiveUserId] = useState<string>();
  const [saving, setSaving] = useState<boolean>(false);

  const dispatch = useDispatch();

  const {
    survey,
    surveyId,
    surveyList,
    noFound,
    message,
    messages,
    fileToSend,
  } = useSelector((state: RootState) => state.auth);
  const [surveyName, setSurveyName] = useState<string>(survey?.name || "");

  const { getUserRequestPayload, updateUserRequestPayload, handleMessages } =
    useSocketActions();
  const { getLocalStorageItem, setLocalStorageItem } = useLocalStorage();

  useEffect(() => {
    const isEditMode = getParameterByName("mode") === "edit";

    if (!isEditMode && getParameterByName("type") === ModalType.Survey) {
      dispatch({
        type: ADD_SURVEY,
        payload: {
          name: null,
          _id: survey._id,
          questions: [],
        },
      });
    }
    setIsEditMode(isEditMode);
    setType(getParameterByName("type"));
    setPageId(getParameterByName("pageId"));
    setLiveUserId(getParameterByName("liveUserId"));
    setConnectionId(getParameterByName("connectionId"));

    setLocalStorageItem("userId", ~~getParameterByName("userId"));
  }, []);

  useEffect(() => {
    setSurveyName(survey?.name);
  }, [survey?.name]);

  const sendAnswerMessageToPage = (
    id: string,
    message: any,
    messageRef?: any,
    originalPageMessageId?: any,
    originalCreatedAt?: any
  ) => {
    const payload = getMessageRequestPayload(
      connectionId,
      liveUserId,
      pageId,
      message,
      messageRef,
      originalPageMessageId,
      originalCreatedAt
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${
        process.env.REACT_APP_ECO_SYSTEM
      }/connection/${connectionId}/page/${pageId}/group/${"members"}`,
      wrapRequestPayload(payload, id)
    );
  };

  useEffect(() => {
    if (surveyId) {
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.SearchInUser,
        getUserRequestPayload(
          getLocalStorageItem("userId"),
          "$",
          getUserSurveyPath()
        ),
        SurveyQuestionTopics.GetSurveyQuestions,
        getParameterByName("cudbServiceId")
      );

      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        SurveyQuestionTopics.GetSurveyQuestions,
        () => {
          setInitLoading(false);
        }
      );
    }
  }, [surveyId]);

  useEffect(() => {
    if (socket.client) {
      if (type === ModalType.Survey) {
        if (getParameterByName("surveyId")) {
          socket.publishToServiceIdSurvey(
            SocketTopics.SurveyTopics,
            UserTopics.SearchInUser,
            getUserRequestPayload(
              getLocalStorageItem("userId"),
              "$",
              getUserSurveyPath()
            ),
            SurveyQuestionTopics.GetSurveyQuestions,
            getParameterByName("cudbServiceId")
          );

          socket.subscribeToSurvey(
            SocketTopics.SurveyTopics,
            SurveyQuestionTopics.GetSurveyQuestions,
            () => {
              setInitLoading(false);
            }
          );
        } else if (getParameterByName("projectId")) {
          socket.publishToServiceIdSurvey(
            SocketTopics.SurveyTopics,
            UserTopics.SearchInUser,
            getUserRequestPayload(
              getLocalStorageItem("userId"),
              "$",
              getProjectPath(getParameterByName("projectId"))
            ),
            ProjectTopics.GetOneProject,
            getParameterByName("cudbServiceId")
          );

          socket.subscribeToSurvey(
            SocketTopics.SurveyTopics,
            ProjectTopics.GetOneProject,
            (res) => {


              console.log('test', res.data[0][0]?.surveyId);

              dispatch({
                type: GET_PROJECT_SURVEY_ID,
                payload: res.data[0][0]?.surveyId,
              });
            }
          );
        }

        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          `${
            process.env.REACT_APP_ECO_SYSTEM
          }/service/live/page/${getParameterByName("pageId")}/group/members`
        );
      } else if (type === ModalType.ExtendedBio) {
        socket.publishToServiceIdSurvey(
          SocketTopics.SurveyTopics,
          UserTopics.SearchInUser,
          getUserRequestPayload(
            getLocalStorageItem("userId"),
            "$",
            getUserRolesPath()
          ),
          ExtendedBioTopics.GetRolesBio,
          getParameterByName("cudbServiceId")
        );

        socket.subscribeToSurvey(
          SocketTopics.SurveyTopics,
          ExtendedBioTopics.GetRolesBio,
          () => {
            setInitLoading(false);
          }
        );

        if (getParameterByName("uId")) {
          socket.publishToServiceIdSurvey(
            SocketTopics.SurveyTopics,
            UserTopics.SearchInUser,
            getUserRequestPayload(
              getParameterByName("uId"),
              "$",
              getExtendedBioPath(getParameterByName("cudbServiceId"))
            ),
            ExtendedBioTopics.GetUserBio,
            getParameterByName("cudbServiceId")
          );

          socket.subscribeToSurvey(
            SocketTopics.SurveyTopics,
            ExtendedBioTopics.GetUserBio,
            (response) => {
              console.log('user bio response', response);
              
              const currentUserBio = response.data[0][0];
              setUser([...(currentUserBio || [])]);
            }
          );
        }
      } else if (type === ModalType.Vehicle) {
        socket.publishToServiceIdSurvey(
          SocketTopics.SurveyTopics,
          UserTopics.SearchInUser,
          getUserRequestPayload(
            getLocalStorageItem("userId"),
            "$",
            getVehicleExtendedBioPath()
          ),
          ExtendedBioTopics.GetVehicleBio,
          getParameterByName("cudbServiceId")
        );

        socket.subscribeToSurvey(
          SocketTopics.SurveyTopics,
          ExtendedBioTopics.GetVehicleBio,
          () => {
            setInitLoading(false);
          }
        );

        if (getParameterByName("uId")) {
          socket.publishToServiceIdSurvey(
            SocketTopics.SurveyTopics,
            UserTopics.SearchInUser,
            getUserRequestPayload(
              getParameterByName("uId"),
              "$",
              getExtendedBioPath(getParameterByName("cudbServiceId"))
            ),
            ExtendedBioTopics.GetUserBio,
            getParameterByName("cudbServiceId")
          );

          socket.subscribeToSurvey(
            SocketTopics.SurveyTopics,
            ExtendedBioTopics.GetUserBio,
            (response) => {
              const currentUserBio = response.data[0][0];
              setUser(currentUserBio);
            }
          );
        }
      }
      if (type === ModalType.Survey && isEditMode) {
        getSurveyMessages(
          getParameterByName("pageId"),
          getParameterByName("connectionId")
        );
      }
    }
  }, [socket.client, type]);

  useEffect(() => {
    if (
      type === ModalType.ExtendedBio &&
      getParameterByName("uId") &&
      Object.keys(user).length
    ) {
      let counter = 0;

      const customFields = survey.questions.map((el) => {
        const question = user.find((question) => question._id === el._id);
        if (question) {
          if (question.value) {
            counter++;
          }
          return question;
        }
        return el;
      });
      setCount(counter);
      dispatch({
        type: GET_SURVEY,
        payload: {
          ...survey,
          questions: customFields,
        },
      });
    }
  }, [user]);

  const applyOps = (op: any, value: any, opValue: any): boolean => {
    switch (op) {
      case MathOps.EqualTo:
        return value === opValue;
      case MathOps.GreaterThan:
        return value > opValue;
      case MathOps.LessThan:
        return value < opValue;
      case LogicalOps.NOT:
        return opValue.indexOf(value) != -1 ? false : true;
      case LogicalOps.OR:
        let isFind = false;
        value.map((el) => {
          if (opValue.indexOf(el) != -1) isFind = true;
        });
        return isFind;
      case LogicalOps.AND:
        return opValue.every((el) => value.indexOf(el) !== -1);
      default:
        return !!value;
    }
  };

  const performActions = (
    logic: ILogic,
    question: IQuestion = selectedQuestionaire
  ): boolean => {
    let destinationQuestion: IQuestion = null;
    switch (logic.action) {
      case MainActions.JumpToQuestion:
        destinationQuestion = survey.questions.find(
          (question: IQuestion) => question._id === logic.jQuestion
        );
        break;
      case MainActions.Notify:
        sendAnswerMessageToPage(survey._id, {
          type: "text",
          attributes: {
            body: logic.jQuestion,
            notify: true,
          },
        });
        break;
      case MainActions.NotifyWait:
        const rsvpMessage = [...messages].reverse().find((message1) => {
          return (
            message1.messageType === "rsvp" &&
            message1?.data?.surveyQuestion?._id === question?._id
          );
        });

        sendAnswerMessageToPage(
          survey._id,
          {
            type: "rsvp",
            attributes: {
              body: logic.jQuestion,
              type: "yesNo",
              options: {
                option1: "Yes",
                option2: "No",
              },
              rsvpTitle: logic.jQuestion,
              surveyQuestion: question,
            },
          },
          rsvpMessage
            ? {
                referenceType: "update",
                pageMessageId: rsvpMessage.pageMessageId,
              }
            : undefined,
          rsvpMessage
            ? rsvpMessage.originalPageMessageId
              ? rsvpMessage.originalPageMessageId
              : rsvpMessage.pageMessageId
            : undefined,
          rsvpMessage ? rsvpMessage.originalPageMessageCreatedAtDate : undefined
        );

        if (rsvpMessage) {
          Object.keys(rsvpMessage.data.responses).map((userId) => {
            sendAnswerMessageToPage(survey._id, {
              type: "removeMessage",
              attributes: {
                messageId: rsvpMessage.data.responses[userId],
              },
            });
          });
        }
        break;
    }

    if (destinationQuestion) {
      setselectedQuestionaire(destinationQuestion);
      return true;
    }
    return false;
  };

  const doLogicActions = (logic: ILogic, question: IQuestion): boolean => {
    let flag = false;

    switch (question.type) {
      case QuestionaireType.Date:
      case QuestionaireType.DateTime:
      case QuestionaireType.Time:
        flag = applyOps(logic.ops, moment(question.value), moment(logic.value));
        break;
      case QuestionaireType.MultipleChoice:
        flag = applyOps(logic.ops, question.value, logic.value);
        break;
      case QuestionaireType.Number:
      case QuestionaireType.Bar:
      case QuestionaireType.Currency:
        flag = applyOps(logic.ops, Number(question.value), Number(logic.value));
        break;
      case QuestionaireType.GPS:
        // TODO: need to consult
        break;
      case QuestionaireType.Name:
      case QuestionaireType.Capture:
      case QuestionaireType.Email:
      case QuestionaireType.File:
      case QuestionaireType.Media:
      case QuestionaireType.Phone:
      case QuestionaireType.Signature:
      case QuestionaireType.Tag:
      case QuestionaireType.TagNot:
      case QuestionaireType.Text:
      case QuestionaireType.ThreeButton:
      case QuestionaireType.YesNo:
      case QuestionaireType.Location:
        flag = applyOps(logic.ops, question.value, null);
        break;
      default:
        break;
    }
    performActions(logic, question);
    return flag;
  };

  const moveBackToQuestionaire = () => {
    if (track.length > 0) {
      const answersTrack = [...track];
      const prevAnswerId = answersTrack.pop();
      setTrack([...answersTrack]);
      const nextQuestaionaireIndex = survey.questions.findIndex(
        (el: IQuestion) => el._id === prevAnswerId
      );
      setselectedQuestionaire(survey.questions[nextQuestaionaireIndex]);
    }
  };

  const onAddQuestionaireClick = () => {
    setSurveyModalDisplayed(true);
    setselectedQuestionaire({
      label: "",
      name: null,
      type: QuestionaireType.ThreeButton,
      value: "",
      options: [],
      logic: [],
    });
    setIsEditQuestion(false);
  };

  const onEditQuestionaireClick = (item) => {
    setSurveyModalDisplayed(true);
    setselectedQuestionaire(item);
    setIsEditQuestion(true);
  };

  const copyQuestionaireAction = (item) => {
    const surveys = [...survey.questions];
    surveys.push({ ...item, _id: uuid() });
    pushNotification(
      "Question copied successfully",
      "successs",
      "TOP_CENTER",
      1000
    );
    dispatch({ type: GET_SURVEY, payload: { ...survey, questions: surveys } });
  };

  const deleteQuestionaireAction = (item) => {
    setselectedQuestionaire(item);
    const surveys = [...survey.questions];
    const index = surveys.findIndex((el) => el._id === item._id);
    surveys.splice(index, 1);
    dispatch({ type: GET_SURVEY, payload: { ...survey, questions: surveys } });
  };

  // const getSurveyMessages = (pageId: string, connectionId: string) => {
  //   socket.subscribeToEvent(
  //     SocketTopics.SubscribePageTopics,
  //     getSearchMessageSubscriptionTopic(pageId, connectionId)
  //   );
  //   const requestId = generateUUID();
  //   localStorage.setItem("requestId", requestId);
  //   localStorage.setItem("requestService", "survey");

  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     getSearchMessagePublishTopic(pageId, connectionId),
  //     wrapRequestPayload(
  //       {
  //         paths: [`$..surveyQuestion`],
  //         returnPaths: ["$"],
  //         resultType: "value",
  //         searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:messageCreatedAtIndex`,
  //         searchQuery: `@pageId:{${pageId}}`,
  //         searchOptions: "SORTBY createdAt DESC ",
  //       },
  //       requestId
  //     )
  //   );
  // };

  const getSurveyMessages = (pageId, connectionId) => {
    const requestId = generateUUID();
    localStorage.setItem("requestId", requestId);
    localStorage.setItem("requestService", "survey");
    const messageRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:message:createdAt`,
          searchQuery: `@pageId:{${pageId.toString()}}`,
          searchOptions: 'TIMEOUT 100',
        },
        load: {object: '$'},
      },
      operations: [
        {
          sortBy: {
            properties: [
              {
                field: '@createdAt',
                order: 'DESC',
              },
            ],
          },
        },
      ],
      result: {
        pagination: {
          offset: 0,
          limit: 1000,
        },
      },
      sortBy: {
        properties: [
          {
            field: "@createdAt",
            order: "DESC",
          },
        ],
        max: 10000,
      },
    };
    dispatch(
      GET_AGGREGATE({
        requestData: messageRequest,
        callback: (response) => {
          console.log('message response', response);
          handleMessages(requestId, response)
        }
      }));
  };

  useEffect(() => {
    if (
      message &&
      message.data.surveyQuestion &&
      message.senderId === liveUserId
    ) {
      const questionIndex = survey.questions.findIndex(
        (el: IQuestion) => el._id === message.data.surveyQuestion._id
      );
      if (
        questionIndex !== -1 &&
        message.messageType !== "rsvp" &&
        message?.refMessage?.referenceType === "remove"
      ) {
        survey.questions[questionIndex].pageMessageId = undefined;
        survey.questions[questionIndex].originalPageMessageCreatedAtDate =
          undefined;
        survey.questions[questionIndex].originalPageMessageId = undefined;
        survey.questions[questionIndex].value = undefined;
        setCount(count - 1);
      }
    }
  }, [message]);

  useEffect(() => {
    if (survey.questions && messages) {
      let counter = 0;
      let pendingRsvps = 0;
      messages
        .filter((message) => {
          return (
            message.senderId === liveUserId && message.messageType !== "rsvp"
          );
        })
        .map((message) => {
          const questionIndex = survey.questions.findIndex(
            (el: IQuestion) => el._id === message.data.surveyQuestion?._id
          );
          let acknowledge = false;
          const rsvpMessage = messages.find((message1) => {
            return (
              message1.messageType === "rsvp" &&
              message1?.data?.surveyQuestion?._id ===
                survey.questions[questionIndex]?._id
            );
          });
          if (rsvpMessage && !rsvpMessage?.data?.responseAnswers) {
            pendingRsvps++;
          } else if (rsvpMessage && rsvpMessage?.data?.responseAnswers) {
            if (rsvpMessage?.data?.responseAnswers) {
              Object.keys(rsvpMessage?.data?.responseAnswers).map((userId) => {
                if (rsvpMessage?.data?.responseAnswers?.[userId] === "Yes") {
                  acknowledge = true;
                }
              });
            }
          }
          if (questionIndex !== -1) {
            survey.questions[questionIndex] = {
              ...message.data.surveyQuestion,
              pageMessageId: message.id,
              originalPageMessageCreatedAtDate: message.originalCreatedAt,
              originalPageMessageId: message.originalPageMessageId,
              ...Object.assign(
                {},
                rsvpMessage && !acknowledge ? { value: "" } : {}
              ),
            };
            if (!rsvpMessage || (rsvpMessage && acknowledge)) counter++;
          }
        });
      if (pendingRsvps > 0) {
        setInitLoading(true);
      } else {
        setInitLoading(false);
      }
      setCount(counter);
    }
  }, [messages, survey]);

  const moveToNextQuestionaire = (answer) => {
    let isLogicApplied = false;
    let logicOp;
    const questionaire = { ...selectedQuestionaire, value: answer };
    const nextQuestaionaireIndex = survey.questions.findIndex(
      (el: IQuestion) => el._id === selectedQuestionaire._id
    );
    if (
      questionaire.value &&
      JSON.stringify(selectedQuestionaire.value) !==
        JSON.stringify(questionaire.value)
    ) {
      for (let i = 0; i < questionaire.logic.length; i++) {
        if (doLogicActions(questionaire.logic[i], questionaire)) {
          isLogicApplied = true;
          logicOp = questionaire.logic[i].action;
          break;
        }
      }
    }
    if (type === ModalType.Survey) {
      if (
        questionaire.value &&
        JSON.stringify(selectedQuestionaire.value) !==
          JSON.stringify(questionaire.value)
      ) {
        let message;
        if (
          typeof questionaire.value === "string" ||
          typeof questionaire.value === "number"
        ) {
          message = {
            type: "text",
            attributes: {
              body: `${questionaire.label}: ${questionaire.value}`,
              surveyQuestion: questionaire,
            },
          };
        } else if (questionaire.value.url) {
          message = {
            type: "media",
            attributes: {
              body: questionaire.label,
              surveyQuestion: questionaire,
              ...questionaire.value,
            },
          };
        } else if (questionaire.value.lat && questionaire.value.lng) {
          message = {
            type: "place",
            attributes: {
              surveyQuestion: questionaire,
              body: questionaire.label,
              attributes: {
                title: questionaire.label,
              },
              display: {
                type: "marker",
                color: "blue",
              },
              coordinates: {
                lat: questionaire.value.lat,
                long: questionaire.value.lng,
              },
            },
          };
        }

        sendAnswerMessageToPage(
          questionaire._id,
          message,
          selectedQuestionaire.pageMessageId
            ? {
                referenceType: "update",
                pageMessageId: selectedQuestionaire.pageMessageId,
              }
            : undefined,
          selectedQuestionaire.pageMessageId
            ? selectedQuestionaire.originalPageMessageId
              ? selectedQuestionaire.originalPageMessageId
              : selectedQuestionaire.pageMessageId
            : undefined,
          selectedQuestionaire.pageMessageId
            ? selectedQuestionaire.originalPageMessageCreatedAtDate
            : undefined
        );
      }
    }

    if (logicOp === MainActions.NotifyWait) {
      setInitLoading(true);
      setSurveyModalDisplayed(false);
      return;
    }

    const answersTrack = [...track];
    answersTrack.push(questionaire._id);
    setTrack([...answersTrack]);

    if (!isLogicApplied || logicOp === MainActions.Notify) {
      if (nextQuestaionaireIndex + 1 < survey.questions.length) {
        const nextQuestion = {
          ...survey.questions[nextQuestaionaireIndex + 1],
        };
        setselectedQuestionaire(nextQuestion);
      }
    }

    if (nextQuestaionaireIndex + 1 >= survey.questions.length) {
      setSurveyModalDisplayed(false);
    }
    survey.questions[nextQuestaionaireIndex] = questionaire;

    dispatch({ type: GET_SURVEY, payload: { ...survey, ...survey.questions } });

    if (questionaire?.value || questionaire?.value?.length) {
      let counter = 0;
      survey.questions.map((el) => {
        if (el?.value || el?.value?.length) {
          counter++;
        }
      });
      setCount(counter);
    }
  };

  const onChangeName = () => {
    const surveys = [...survey.questions];
    const storedSurveyList = [...surveyList];
    const storedSurveyIndex = surveyList.findIndex(
      (el) => el._id === survey._id
    );
    if (storedSurveyIndex >= 0) {
      storedSurveyList.splice(storedSurveyIndex, 1, {
        ...survey,
        name: surveyName,
        questions: surveys,
      });
    } else {
      storedSurveyList.splice(storedSurveyIndex, 0, {
        ...survey,
        name: surveyName,
        questions: surveys,
      });
    }
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.UpdateUser,
      updateUserRequestPayload(
        getLocalStorageItem("userId"),
        "replace",
        getUserSurveyPath(),
        storedSurveyList
      ),
      SurveyQuestionTopics.UpdateSurveyQuestion,
      getParameterByName("cudbServiceId")
    );

    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      SurveyQuestionTopics.UpdateSurveyQuestion,
      () => {
        setInitLoading(false);
      }
    );
    pushNotification(
      "Name changed successfully",
      "successs",
      "TOP_CENTER",
      1000
    );
    dispatch({
      type: GET_SURVEY,
      payload: { ...survey, name: surveyName, questions: surveys },
    });
  };

  const onCreateQuestionaire = (item) => {
    let surveys = [];
    if (isEditQuestion) {
      surveys = [...survey.questions];
      const itemIndex = surveys.findIndex((el) => el._id === item._id);
      surveys.splice(itemIndex, 1, item);
    } else {
      surveys = [...survey.questions];
      surveys.push({ ...item, _id: uuid() });
    }

    dispatch({ type: GET_SURVEY, payload: { ...survey, questions: surveys } });
    setSurveyModalDisplayed(false);
  };

  const onCancel = () => {
    setSurveyModalDisplayed(false);
  };

  const publish = () => {
    const storedSurveyList = [...surveyList];
    const storedSurveyIndex = surveyList.findIndex(
      (el) => el._id === survey._id
    );
    if (type === ModalType.Survey) {
      if (storedSurveyIndex >= 0) {
        storedSurveyList.splice(storedSurveyIndex, 1, {
          ...survey,
          name: surveyName,
          questions: survey.questions,
        });
      } else {
        storedSurveyList.splice(storedSurveyIndex, 0, {
          ...survey,
          name: surveyName,
          questions: survey.questions,
        });
      }
    } else if (type === ModalType.ExtendedBio) {
      if (storedSurveyIndex >= 0) {
        storedSurveyList.splice(storedSurveyIndex, 1, {
          _id: survey._id,
          name: survey.name,
          permissions: surveyList[storedSurveyIndex].permissions,
          extendedBio: survey.questions,
        });
      } else {
        storedSurveyList.splice(storedSurveyIndex, 0, {
          _id: survey._id,
          name: survey.name,
          permissions: surveyList[storedSurveyIndex].permissions,
          extendedBio: survey.questions,
        });
      }
    }

    let notification = "";
    if (type === ModalType.Survey) {
      setInitLoading(true);
      notification = "Survey added successfully";
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.UpdateUser,
        updateUserRequestPayload(
          getLocalStorageItem("userId"),
          "replace",
          getUserSurveyPath(),
          storedSurveyList
        ),
        SurveyQuestionTopics.UpdateSurveyQuestion,
        getParameterByName("cudbServiceId")
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        SurveyQuestionTopics.UpdateSurveyQuestion,
        (data) => {
          setInitLoading(false);
          pushNotification(notification, "successs", "TOP_CENTER", 1000);
        }
      );
    } else if (type === ModalType.ExtendedBio && !isEditMode) {
      setInitLoading(true);
      notification = "Extended Bio added successfully";
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.UpdateUser,
        updateUserRequestPayload(
          getLocalStorageItem("userId"),
          "replace",
          getUserRolesPath(),
          storedSurveyList
        ),
        ExtendedBioTopics.UpdateRoleBio,
        getParameterByName("cudbServiceId")
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        ExtendedBioTopics.UpdateRoleBio,
        (data) => {
          setInitLoading(false);
          pushNotification(notification, "successs", "TOP_CENTER", 1000);
        }
      );
    } else if (type === ModalType.Vehicle) {
      const extendedBio = survey?.questions;
      setInitLoading(true);
      notification = "Vehicle extended added successfully";
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.UpdateUser,
        updateUserRequestPayload(
          getLocalStorageItem("userId"),
          "replace",
          getVehicleExtendedBioPath(),
          extendedBio
        ),
        SurveyQuestionTopics.UpdateSurveyQuestion,
        getParameterByName("cudbServiceId")
      );
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        SurveyQuestionTopics.UpdateSurveyQuestion,
        (data) => {
          setInitLoading(false);
          pushNotification(notification, "successs", "TOP_CENTER", 1000);
        }
      );
    }
  };

  const pdfGenerator = async () => {
    const blob = await pdf(<MyDocument data={survey} />).toBlob();
    const file = new File([blob], `${survey._id}.pdf`, {
      type: blob.type,
      lastModified: new Date().getTime(),
    });
    let form = new FormData();
    form.append("file", file);
    form.append("info", JSON.stringify({}));
    const id = survey._id;
    dispatch(UPLOAD_MEDIA({ form, id }));
    setSaving(true);
  };

  useEffect(() => {
    if (fileToSend && fileToSend.id === survey._id) {
      setSaving(false);
      sendAnswerMessageToPage(survey._id, {
        type: "media",
        attributes: {
          body: fileToSend.media.originalName,
          ...fileToSend.media,
        },
      });
      dispatch({ type: "ADD_FILE", payload: undefined });
      const request = { type: "surveyDidSubmit" };
      window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
        JSON.stringify(request)
      );
      try {
        JSBridge?.jsMessageHandler(JSON.stringify(request));
      } catch (e) {
        console.log("js bridge does not exist");
      }
      pushNotification(
        "Survey PDF submitted successfully",
        "successs",
        "TOP_CENTER",
        1000
      );
    }
  }, [fileToSend]);

  const submit = () => {
    if (type === ModalType.ExtendedBio) {
      setInitLoading(true);
      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.UpdateUser,
        updateUserRequestPayload(
          getParameterByName("uId"),
          "replace",
          getExtendedBioPath(getParameterByName("cudbServiceId")),
          [...survey.questions]
        ),
        ExtendedBioTopics.UpdateUserBio,
        getParameterByName("cudbServiceId")
      );

      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        ExtendedBioTopics.UpdateUserBio,
        (data) => {
          setInitLoading(false);
          pushNotification(
            "Extended Bio Updated.",
            "successs",
            "TOP_CENTER",
            1000
          );
        }
      );
    }
    if (type === ModalType.Survey) {
      pdfGenerator();
    }
  };

  return (
    <Modal
      title=""
      visible={true}
      width="100%"
      className="beam-modal survey-modal"
      footer={[]}
      onCancel={() => {}}
    >
      {type === ModalType.ExtendedBio && isEditMode && (
        <Row className="pdf-icon d-flex justify-content-end mr-4">
          <Col>
            <a title="Generate Pdf" onClick={pdfGenerator}>
              <ReactSVG src="/images/pdf-icon.svg" />
            </a>
          </Col>
        </Row>
      )}

      <Row className="d-flex m-4">
        <Col>
          <h4>Project Name: {survey?.name}</h4>
        </Col>

        {isEditMode ? (
          <Col>
            <h5>
              Answered: {count} out of {survey?.questions?.length}
            </h5>
          </Col>
        ) : (
          <Col>
            <h5>Total Questions: {survey?.questions?.length}</h5>
          </Col>
        )}
      </Row>

      <hr />
      {!noFound && !isEditMode && type === ModalType.Survey && (
        <Row className="mt-4 mb-4 ml-4 w-50">
          <Col>
            <Input
              value={surveyName}
              placeholder="Edit Survey Name"
              onChange={(e) => {
                setSurveyName(e.target.value);
              }}
            />
          </Col>
          <Col className="ml-2 mt-1">
            <Button
              className="beam-btn green-btn cover w-full"
              onClick={onChangeName}
            >
              Edit Name
            </Button>
          </Col>
        </Row>
      )}

      {!noFound && !isEditMode && (
        <div>
          {!survey?.questions?.length && (
            <Row>
              <AddQuestionareButton onClick={onAddQuestionaireClick} />
              <h5 className="mt-1 ml-1">Add Question</h5>
            </Row>
          )}
        </div>
      )}
      <div className="filter-card-1">
        <List
          className="demo-loadmore-list"
          loading={initLoading}
          itemLayout="horizontal"
          dataSource={survey?.questions}
          renderItem={(item, index) => (
            <List.Item
              actions={
                !isEditMode
                  ? [
                      <AddQuestionareButton onClick={onAddQuestionaireClick} />,
                      <EditQuestionaireButton
                        onClick={() => onEditQuestionaireClick(item)}
                      />,
                      <CopyQuestionareButton
                        onClick={() => copyQuestionaireAction(item)}
                      />,
                      <DeleteQuestionareButton
                        onClick={() => deleteQuestionaireAction(item)}
                      />,
                    ]
                  : [
                      item?.value || item?.value?.length ? (
                        <EditQuestionaireCheckboxButton
                          onClick={() => onEditQuestionaireClick(item)}
                        />
                      ) : (
                        <EditQuestionaireButton
                          onClick={() => onEditQuestionaireClick(item)}
                        />
                      ),
                    ]
              }
            >
              <Skeleton title={false} loading={false} active>
                <List.Item.Meta title={`Q${index + 1}. ` + item.label} />
              </Skeleton>
            </List.Item>
          )}
        />
      </div>
      {surveyModalDisplayed && (
        <AddSurveyModal
          data={selectedQuestionaire}
          moveNext={(answer) => moveToNextQuestionaire(answer)}
          moveBack={moveBackToQuestionaire}
          onCreate={onCreateQuestionaire}
          onCancel={onCancel}
          isEditMode={isEditMode}
          isEditQuestion={isEditQuestion}
          type={type}
          count={count}
          totalQuestions={survey?.questions?.length}
        />
      )}

      {!isEditMode && !noFound && (
        <Row className="pr-2 d-flex justify-content-end">
          <Button className="beam-btn green-btn cover" onClick={publish}>
            Publish
          </Button>
        </Row>
      )}

      {isEditMode && !noFound && (
        <Row className="d-flex justify-content-end">
          <Button
            className="beam-btn green-btn cover"
            onClick={submit}
            loading={saving}
          >
            Submit
          </Button>
        </Row>
      )}
    </Modal>
  );
};

export default SurveyListModal;
